import React, { useEffect } from "react";
import { MathJax } from "better-react-mathjax";

import style from "./TitlePanel.css"


const TitlePanel = ({title, formula}) => {
    return (
        <div className="title-panel">
            <div className="title-panel-title">
                <h5>{title}</h5>
            </div>
            <div className="title-panel-background">
            </div>
            <div className="title-panel-formula">
                    <MathJax dynamic>
                        <span>{}</span>
                        <h4 style={{ textAlign: "center" }}>{formula}</h4>
                    </MathJax>{" "}
            </div>
        </div>
    );
}

export default TitlePanel;